enum TeachingAidOptionType {
    PSP1 = 1,
    PSP2 = 2,
    Unknown
  }
  
  export default TeachingAidOptionType;